/**
 * Supplies button semantics for legacy theme controls rendered as paragraphs
 * or spans. Existing theme handlers already provide click and keyboard action;
 * this keeps their accessible role and expanded state available to AT.
 */
(function () {
  'use strict';

  var selector = '[data-accordion-toggle], [data-collection-sidebar-heading][tabindex="0"]';
  var tabStripSelector = 'ul.tabs, ul.product-tabs-title';

  var uidCounter = 0;
  function nextId(prefix) {
    uidCounter += 1;
    return prefix + '-' + uidCounter;
  }

  function enhance(root) {
    if (root.nodeType === 1 && root.matches(selector)) enhanceControl(root);
    if (!root.querySelectorAll) return;
    root.querySelectorAll(selector).forEach(enhanceControl);
    if (root.nodeType === 1 && root.matches(tabStripSelector)) enhanceTabStrip(root);
    root.querySelectorAll(tabStripSelector).forEach(enhanceTabStrip);
  }

  function syncExpanded(control) {
    var open = control.classList.contains('is-open') || control.classList.contains('is-active');
    control.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function enhanceControl(control) {
    if (!control.hasAttribute('role')) control.setAttribute('role', 'button');
    syncExpanded(control);
    if (control.dataset.a11yStateObserved) return;
    control.dataset.a11yStateObserved = 'true';
    new MutationObserver(function () { syncExpanded(control); })
      .observe(control, { attributes: true, attributeFilter: ['class'] });
  }

  /* Tab strips (product-tabs, homepage tab-collection sections, size-guide
     modal) are plain <ul class="tabs">/<li class="tab-link"> markup with no
     role, aria-selected or aria-controls. The active tab is marked with the
     theme's own "current" class (assets/theme.dev.js GlobalTabs component --
     distinct from the "is-open"/"is-active" classes the accordions above
     use), so it needs its own selected-state check. */
  function syncTabSelected(tab) {
    var selected = tab.classList.contains('current');
    tab.setAttribute('aria-selected', selected ? 'true' : 'false');
  }

  function enhanceTabStrip(list) {
    if (list.dataset.a11yTablist) return;
    var tabs = list.querySelectorAll('li.tab-link[tabindex="0"]');
    if (!tabs.length) return;
    list.dataset.a11yTablist = 'true';
    list.setAttribute('role', 'tablist');

    var holder = list.closest('[data-tabs-holder]') || list.parentElement;

    tabs.forEach(function (tab) {
      tab.setAttribute('role', 'tab');
      syncTabSelected(tab);

      var index = tab.getAttribute('data-tab');
      var panel = index != null && holder ? holder.querySelector('.tab-content-' + index) : null;

      if (panel) {
        if (!tab.id) tab.id = nextId('a11y-tab');
        if (!panel.id) panel.id = nextId('a11y-tabpanel');
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        tab.setAttribute('aria-controls', panel.id);
      }

      if (!tab.dataset.a11yStateObserved) {
        tab.dataset.a11yStateObserved = 'true';
        new MutationObserver(function () { syncTabSelected(tab); })
          .observe(tab, { attributes: true, attributeFilter: ['class'] });
      }
    });
  }

  function init() {
    enhance(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(enhance);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
